{
  "All Invoices": "Toutes les factures — {{name}}",
  "View Invoice": "Voir la facture",
  "invoices_one": "{{count}} facture",
  "invoices_other": "{{count}} factures",
  "You currently don't have any invoices here": "Vous n'avez actuellement aucune facture ici",
  "Back": "Retour"
}
